import SELLER_LIST from "./sellerList";

export default SELLER_LIST;
